import { HomeVideoPage } from './HomeVideoPage';
export default HomeVideoPage;
